import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Link } from "react-router-dom";

class MenuConfig extends Component {
  render() {
    return (
      <div className="dashboard-component" style={{ textAlign: "center" }}>
        <div className="row">
          <div className="col s12 m6 offset-m3">
            <div className="card grey darken-5">
              <div className="card-action">
                <span className="card-title">Configuration Settings</span>
              </div>
              <div className="card-content white-text">
                <div className="row">
                  <div className="col s12 txt-center">Manage your options.</div>
                  <div className="col s12 txt-center">
                    <div className="top10">
                      <Link
                        to="/menus/config/brand"
                        className="waves-effect waves-light btn btn-small"
                      >
                        Brands
                      </Link>
                    </div>
                    <div className="top10">
                      <Link
                        to="/menus/config/category"
                        className="waves-effect waves-light btn btn-small"
                      >
                        Categories
                      </Link>
                    </div>
                    <div className="top10">
                      <Link
                        to="/menus/config/terpeneprofiles"
                        className="waves-effect waves-light btn btn-small"
                      >
                        Terpene Profiles
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-action"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { auth: state.auth, subscription: state.subscription };
}

export default connect(
  mapStateToProps,
  actions
)(MenuConfig);
